'use strict'
/**
 * z.js — HOTFIX interop zod (incidente prod 2026-06-11)
 * ════════════════════════════════════════════════════════
 * CAUSA RAÍZ del blanco en prod: `const { z } = require('zod')` funciona en
 * Node (exports.require → index.cjs expone { z }) pero el bundle de CRA
 * resuelve la condición "import"/"module" (build ESM) y tras el interop
 * CJS↔ESM de webpack el namespace NO expone `.z` → z undefined →
 * "Cannot read properties of undefined (reading 'object')" en el PRIMER
 * módulo de contratos → index.js muere antes de root.render → app en blanco.
 *
 * Jest/Node resolvían bien (por eso 1411 tests verdes): el gate del MACRO 1
 * nunca EJECUTÓ el bundle real. Lección incorporada al gate de este hotfix.
 *
 * Este shim es el ÚNICO punto de import de zod para src/contracts/ y cubre
 * todas las formas de resolución:
 *   - Node CJS:        m.z existe            → m.z
 *   - ESM interop:     namespace con default → m.default.z o m.default
 *   - ESM aplanado:    el namespace ES z     → m
 */
const m = require('zod')
const z = (m && m.z) || (m && m.default && (m.default.z || m.default)) || m

if (!z || typeof z.object !== 'function') {
  // Fail-loud coherente con la doctrina: si zod no resuelve, que grite claro
  throw new Error('[contracts/z] interop de zod falló: z.object no es función — revisar resolución del bundler')
}

module.exports = { z }
